module.exports = __webpack_public_path__ + "img/Pic_YDCF_d.57b76add.gif";